// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Vc+Q5","text":"styles_text__gFA5l","input":"styles_input__yx3NQ","left":"styles_left__kQQk6","right":"styles_right__fjsaH","link":"styles_link__rYyUI"};